import { render } from "./IntegrateWithText.vue?vue&type=template&id=7c1c225c&scoped=true"
import script from "./IntegrateWithText.vue?vue&type=script&lang=js"
export * from "./IntegrateWithText.vue?vue&type=script&lang=js"

import "./IntegrateWithText.vue?vue&type=style&index=0&id=7c1c225c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1c225c"]])

export default __exports__